"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatEventMetaDTO = exports.ChatEventDTO = void 0;
class ChatEventDTO {
    meta;
    payload;
}
exports.ChatEventDTO = ChatEventDTO;
class ChatEventMetaDTO {
    sender;
    receiver;
}
exports.ChatEventMetaDTO = ChatEventMetaDTO;
